import { OWA_AUTO_LINKS_CLASSNAME } from './constants';
var classNames = require('classnames/bind');
export default function trySetIdAndClassName(anchorElement) {
    if (!anchorElement.id || anchorElement.id.length === 0) {
        anchorElement.id = Math.round(Math.random() * 1000000).toString();
    }
    if (anchorElement.className.indexOf(OWA_AUTO_LINKS_CLASSNAME) !== -1) {
        return;
    }
    anchorElement.className = classNames(anchorElement.className, OWA_AUTO_LINKS_CLASSNAME);
}
//# sourceMappingURL=trySetIdAndClassName.js.map